import { CloudCommand } from "../types.js";

export const sendMessage: CloudCommand = {
    action: "MESSAGE/SEND",
    commandName: "message.sendMessage",
    buildPayload: ({ params }) => params,
};
